import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminGeneratorEdit from "@/pages/admin/AdminGeneratorEdit";

export const Route = createFileRoute("/admin/generators/$id")({
  component: () => (
    <ProtectedRoute>
      <AdminGeneratorEdit />
    </ProtectedRoute>
  ),
});
